import { render, staticRenderFns } from "./tripDetail.vue?vue&type=template&id=4472904c&scoped=true"
import script from "./tripDetail.vue?vue&type=script&lang=js"
export * from "./tripDetail.vue?vue&type=script&lang=js"
import style0 from "./tripDetail.vue?vue&type=style&index=0&id=4472904c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4472904c",
  null
  
)

export default component.exports